<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">配置数据</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="140px" :rules="rules" ref="fromRef">
        <el-form-item label="小程序名称:" prop="appletName"> <el-input v-model="basicInfo.appletName"></el-input> </el-form-item>
        <el-form-item label="小程序ID:" prop="appId"> <el-input v-model="basicInfo.appId"></el-input> </el-form-item>
        <el-form-item label="小程序秘钥:" prop="wxsecret"> <el-input v-model="basicInfo.wxsecret"></el-input> </el-form-item>
        <el-form-item label="小程序图标:" prop="icon">
          <el-upload action="#" :show-file-list='false' :http-request="(e) => uploadImg(e, 'icon')">
            <el-button type="primary" round>上传</el-button>
          </el-upload>
          <el-image v-show="basicInfo.icon" v-model="basicInfo.icon" style="max-width:200px;margin-top: 10px;" class='yingye' :src="basicInfo.icon" fit="cover" :preview-src-list="[basicInfo.icon]">
          </el-image>
        </el-form-item>
        <el-form-item label="独立收款:" prop="wechatPay">
          <el-switch v-model="basicInfo.wechatPay" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="handleWechatPayChange"></el-switch>
        </el-form-item>
        <div v-if="basicInfo.wechatPay == 1">
          <el-form-item label="商户Id:" prop="merchantId">
            <template slot="label">
              <!-- <span style="color: #f56c6c;">*</span>  --> 商户Id: </template>
            <el-input v-model="basicInfo.merchantId" placeholder="请输入商户Id"></el-input>
          </el-form-item>
          <el-form-item label="私钥路径:" prop="privateKeyPath">
            <template slot="label">
              <!-- <span style="color: #f56c6c;">*</span>  --> 私钥路径: </template>
            <el-input v-model="basicInfo.privateKeyPath" placeholder="请输入私钥路径"></el-input>
          </el-form-item>
          <el-form-item label="证书序列号:" prop="merchantSerialNumber">
            <template slot="label">
              <!-- <span style="color: #f56c6c;">*</span>  --> 证书序列号: </template>
            <el-input v-model="basicInfo.merchantSerialNumber" placeholder="请输入证书序列号"></el-input>
          </el-form-item>
          <el-form-item label="APIv3秘钥:" prop="apiV3Key">
            <template slot="label">
              <!-- <span style="color: #f56c6c;">*</span>  --> APIv3秘钥: </template>
            <el-input v-model="basicInfo.apiV3Key" placeholder="请输入APIv3秘钥"></el-input>
          </el-form-item>
          <el-form-item label="是否使用公钥验签:" prop="wechatPublicPay">
            <el-switch v-model="basicInfo.wechatPublicPay" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" @change="handlePublicKeyChange"></el-switch>
          </el-form-item>
          <el-form-item v-if="basicInfo.wechatPublicPay" label="公钥路径:" prop="publicKeyPath">
            <template slot="label">
              <span style="color: #f56c6c;">*</span> 公钥路径: </template>
            <el-input v-model="basicInfo.publicKeyPath" placeholder="请输入公钥路径"></el-input>
          </el-form-item>
          <el-form-item v-if="basicInfo.wechatPublicPay" label="公钥Id:" prop="publicKeyId">
            <template slot="label">
              <span style="color: #f56c6c;">*</span> 公钥Id: </template>
            <el-input v-model="basicInfo.publicKeyId" placeholder="请输入公钥Id"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="submit">保存</el-button>
    </div>
  </div>
</template>
<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { saveOrUpdateWxConfig, queryWxConfigByStoreId } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        wechatPay: 0,
        appletName: '',
        appId: '',
        wxsecret: '',
        icon: '',
        merchantId: '',
        privateKeyPath: '',
        merchantSerialNumber: '',
        apiV3Key: '',
        wechatPublicPay: 0,
        publicKeyPath: '',
        publicKeyId: ''
      },
      platformType: [],
      isRepeat: false,
      isCheckedRepeat: false,
      rules: {
        appletName: [
          { required: true, message: '请输入小程序名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入小程序ID', trigger: 'blur' }
        ],
        wxsecret: [
          { required: true, message: '请输入小程序密钥', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传小程序图标', trigger: 'change' }
        ],
        wechatPay: [
          { required: true, message: '请选择是否开启独立收款', trigger: 'change' }
        ],
        // merchantId: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.basicInfo.wechatPay == 1 && !value) {
        //         callback(new Error('请输入商户Id'))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
        // privateKeyPath: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.basicInfo.wechatPay == 1 && !value) {
        //         callback(new Error('请输入私钥路径'))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
        // merchantSerialNumber: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.basicInfo.wechatPay == 1 && !value) {
        //         callback(new Error('请输入证书序列号'))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
        // apiV3Key: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.basicInfo.wechatPay == 1 && !value) {
        //         callback(new Error('请输入APIv3秘钥'))
        //       } else {
        //         callback()
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ], 
        publicKeyPath: [
          {
            validator: (rule, value, callback) => {
              if (this.basicInfo.wechatPay == 1 && this.basicInfo.wechatPublicPay && !value) {
                callback(new Error('请输入公钥路径'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        publicKeyId: [
          {
            validator: (rule, value, callback) => {
              if (this.basicInfo.wechatPay == 1 && this.basicInfo.wechatPublicPay && !value) {
                callback(new Error('请输入公钥Id'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    let id = this.$route.query.storeId
    if (id) {
      queryWxConfigByStoreId(id).then(res => {
        if (res.data.success) {
          if (res.data.data.length) {
            const data = res.data?.data[0]
            // 确保数据类型正确
            this.basicInfo = {
              ...data,
              wechatPublicPay: data.wechatPublicPay,
              publicKeyPath: String(data.publicKeyPath || ''),
              publicKeyId: String(data.publicKeyId || '')
            }
          }
        }
      })
    }
    this.basicInfo.storeId = this.$route.query.storeId
  },
  methods: {
    // 确认提交
    submit () {
      this.$refs.fromRef.validate((valid) => {
        if (!valid) {
          return
        }
        // 准备提交数据，确保数据类型正确
        const submitData = {
          ...this.basicInfo,
          wechatPublicPay: this.basicInfo.wechatPublicPay,
          publicKeyPath: String(this.basicInfo.publicKeyPath || ''),
          publicKeyId: String(this.basicInfo.publicKeyId || '')
        }
        saveOrUpdateWxConfig(submitData).then((res) => {
          if (res.data.success) {
            this.$message.success('保存成功')
            this.$router.go(-1)
          }
        })
      })
    },
    uploadImg (e, key) {
      console.log(e, key)
      let file = e.file
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3, [], (e) => {
      }).then(res => {
        if (res === 'error') {
          this.$message.error('服务器问题，请刷新页面重试或联系管理员')
          return
        }
        console.log(res, '11111')
        if (key === 'icon') {
          this.basicInfo.icon = res
          // 触发图标字段的验证
          this.$nextTick(() => {
            this.$refs.fromRef.validateField('icon')
          })
        } else {
          // this.basicInfo.licenseUrl = res
        }
        this.$forceUpdate()
      })
    },
    // 处理独立收款开关变化
    handleWechatPayChange () {
      // 当独立收款关闭时，清除相关字段的验证错误
      if (this.basicInfo.wechatPay !== 1) {
        this.$nextTick(() => {
          this.$refs.fromRef.clearValidate(['merchantId', 'privateKeyPath', 'merchantSerialNumber', 'apiV3Key', 'publicKeyPath', 'publicKeyId'])
        })
      }
      // 开启时不立即触发验证，等待用户操作后再验证
    },
    // 处理公钥验签开关变化
    handlePublicKeyChange () {
      // 当公钥验签关闭时，清除公钥相关字段的验证错误
      if (!this.basicInfo.wechatPublicPay) {
        this.$nextTick(() => {
          this.$refs.fromRef.clearValidate(['publicKeyPath', 'publicKeyId'])
        })
      }
      // 开启时不立即触发验证，等待用户操作后再验证
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
